import React, { Component } from 'react';
import { connect } from 'react-redux';
import './DepositsTable.css';
import { getCurrentUser } from 'selectors/authentication';
import { TYPES, usersUtil } from 'services/utils/users-util';
import SimpleTable from 'components/shared/table/SimpleTable';
import {
  getCurrentPage,
  getDeposits,
  getUsersByClientId,
} from 'selectors/admin/deposits/deposits';
import {
  loadDepositsRequest,
  loadDepositRequest,
  goToDeposit,
  loadUsersRequest,
} from 'actions/admin/deposits/deposits';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import { toUpperFirstLetter } from 'services/utils/text-util';

class DepositsTable extends Component {
  render() {
    let tableHeaders;
    if (usersUtil.hasType(this.props.currentUser, TYPES.CLIENT)) {
      tableHeaders = ['WO #', 'NAME', 'STATUS', 'CREATED DATE', 'AMOUNT'];
    } else {
      tableHeaders = [
        'WO #',
        'NAME',
        'CLIENT NAME',
        'STATUS',
        'CREATED DATE',
        'AMOUNT',
      ];
    }

    return (
      <div>
        {this.props.deposits !== null && (
          <div>
            <SimpleTable
              className="deposits-table"
              headers={tableHeaders}
              rows={this.mapDeposits(this.props.deposits.content)}
              emptyMessage="No Deposits"
              onRowSelected={this.handleDepositSelection}
            />

            <div className="pagination-container">
              <SimplePagination
                currentPage={this.props.currentPage}
                pageSize={this.props.deposits.pageSize}
                total={this.props.deposits.total}
                onPageChange={this.handlePageChange}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    this.props.dispatch(loadDepositsRequest(1));
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  handlePageChange = (newPage) => {
    this.props.dispatch(loadDepositsRequest(newPage));
  };

  handleDepositSelection = (index) => {
    this.props
      .dispatch(loadDepositRequest(this.props.deposits.content[index].id))
      .then((response) => {
        simpleScrollToTop();
        // When deposit is loaded successfully, go to deposit page
        if (response.ok) {
          this.props.dispatch(
            goToDeposit(this.props.deposits.content[index].id)
          );

          if (
            this.props.usersByClientId[response.deposit.client.id] === undefined
          ) {
            this.props.dispatch(loadUsersRequest(response.deposit.client.id));
          }
        }
      });
  };

  mapDeposits = (deposits) => {
    return deposits.map((deposit) => {
      if (usersUtil.hasType(this.props.currentUser, TYPES.CLIENT)) {
        return [
          <span className="h4">{deposit.work_order.number}-D</span>,
          deposit.work_order.name !== null ? deposit.work_order.name : 'N/A',
          toUpperFirstLetter(deposit.status),
          <Date value={deposit.created_at} format="LL" />,
          <Number value={deposit.cost} format="$0,0" />,
        ];
      } else {
        return [
          <span className="h4">{deposit.work_order.number}-D</span>,
          deposit.work_order.name !== null ? deposit.work_order.name : 'N/A',
          <span className="h4">{deposit.client.company_name}</span>,
          toUpperFirstLetter(deposit.status),
          <Date value={deposit.created_at} format="LL" />,
          <Number value={deposit.cost} format="$0,0" />,
        ];
      }
    });
  };
}

export default connect((state) => {
  return {
    currentUser: getCurrentUser(state),
    currentPage: getCurrentPage(state),
    deposits: getDeposits(state),
    usersByClientId: getUsersByClientId(state),
  };
})(DepositsTable);



// WEBPACK FOOTER //
// ./src/components/admin/invoices/DepositsTable.js